import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes, { any } from 'prop-types'
import { DataGrid } from '@mui/x-data-grid'
import Constants from '../../../../../constants/en.json'
import { useTheme } from '../../../../../components/mui/Styles/index'
import { getCurrencyFormattedValue } from '../../../../../utils/string-utils'
import NoResultsFoundTableOverlay from '../../../../../components/NoResultsFoundTableOverlay/no-results-found-table-overlay'

function DmsOrderLineTable({ filterBy, filterValue, searchByOptions }) {
  const theme = useTheme()
  const dmsOrderLineDetails = useSelector((state) => state.orderList.dmsOrderLineDetails)
  const selectedSearchOption = searchByOptions.filter((option) => {
    return option.id === filterBy
  })
  const filterByDescription = selectedSearchOption[0]?.text || ''

  const rows = dmsOrderLineDetails?.map((row) => ({
    id: row.lineNumber,
    lineNumber: row.lineNumber,
    itemNumber: row.itemNumber,
    itemDescription: row.itemDescription,
    orderedQuantity: row.orderedQuantity,
    unitPrice: row.unitPrice,
    uom: row.uom,
  }))

  const columns = [
    {
      field: 'lineNumber',
      headerName: Constants.orders.order_line_details.INDEX,
      flex: 0.1,
      minWidth: 85,
      headerAlign: 'right',
      align: 'right',
    },
    {
      field: 'itemNumber',
      headerName: Constants.orders.order_details.NDC_ITEM,
      flex: 1,
      minWidth: 120,
    },
    {
      field: 'itemDescription',
      headerName: Constants.orders.order_details.ITEM_DESCRIPTION,
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'orderedQuantity',
      headerName: Constants.orders.order_line_details.QTY_ORD,
      headerAlign: 'right',
      align: 'right',
      flex: 0.5,
      minWidth: 100,
    },
    {
      field: 'unitPrice',
      headerName: Constants.orders.order_details.UNIT_PRICE,
      headerAlign: 'right',
      align: 'right',
      valueFormatter: (value) =>
        value ? getCurrencyFormattedValue(value) : Constants.orders.order_details.PENDING,
      flex: 0.5,
      minWidth: 80,
    },
    {
      field: 'uom',
      headerName: Constants.orders.order_details.ORDER_UOM,
      flex: 0.5,
      minWidth: 80,
    },
  ]

  const gridStyle = {
    backgroundColor: theme.palette.common.white,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: theme.palette.grey[300],
  }

  const filterModel = {
    items: [{ field: filterBy, operator: 'contains', value: filterValue }],
  }

  return (
    <DataGrid
      sx={gridStyle}
      rows={rows}
      columns={columns}
      spacing={1}
      pageSizeOptions={[25, 50]}
      filterModel={filterModel}
      initialState={{
        pagination: {
          paginationModel: { pageSize: 25, page: 0 },
        },
      }}
      slotProps={{
        pagination: {
          component: 'div',
          showLastButton: true,
          showFirstButton: true,
        },
        noResultsOverlay: {
          filterByDescription,
          noResultsValue: filterValue,
        },
      }}
      slots={{
        noResultsOverlay: NoResultsFoundTableOverlay,
      }}
      disableColumnFilter
      disableRowSelectionOnClick
    />
  )
}

DmsOrderLineTable.propTypes = {
  filterBy: PropTypes.string.isRequired,
  filterValue: PropTypes.string.isRequired,
  searchByOptions: PropTypes.arrayOf(PropTypes.objectOf(any)).isRequired,
}

export default DmsOrderLineTable
